export * from './wixDataSettings';
export * from './datasetTypes';
export * from './readWriteModes';
export var AppCollectionVisibility;
(function (AppCollectionVisibility) {
    AppCollectionVisibility["HIDDEN"] = "hidden";
    AppCollectionVisibility["VISIBLE"] = "visible";
})(AppCollectionVisibility || (AppCollectionVisibility = {}));
export var DynamicPageUrlValidationError;
(function (DynamicPageUrlValidationError) {
    DynamicPageUrlValidationError["URL_TOO_LONG"] = "URL_TOO_LONG";
    DynamicPageUrlValidationError["PREFIX_STARTS_WITH_TEXT"] = "PREFIX_STARTS_WITH_TEXT";
    DynamicPageUrlValidationError["NO_FIELD_IN_PREFIX"] = "NO_FIELD_IN_PREFIX";
    DynamicPageUrlValidationError["NO_SPECIAL_CHARS"] = "NO_SPECIAL_CHARS";
    DynamicPageUrlValidationError["NO_DELETED_FIELD"] = "NO_DELETED_FIELD";
    DynamicPageUrlValidationError["ONLY_EXISTING_FIELDS"] = "ONLY_EXISTING_FIELDS";
    DynamicPageUrlValidationError["PATTERN_ALREADY_EXISTS"] = "PATTERN_ALREADY_EXISTS";
    DynamicPageUrlValidationError["SEPARATE_FIELDS"] = "SEPARATE_FIELDS";
    DynamicPageUrlValidationError["UNSUPPORTED_FIELDS"] = "UNSUPPORTED_FIELDS";
    DynamicPageUrlValidationError["URL_EMPTY"] = "URL_EMPTY";
    DynamicPageUrlValidationError["NO_VARIABLE"] = "NO_VARIABLE";
    DynamicPageUrlValidationError["EXACT_PATTERN_EXISTS"] = "EXACT_PATTERN_EXISTS";
})(DynamicPageUrlValidationError || (DynamicPageUrlValidationError = {}));
export var BEHAVIOR_TYPE;
(function (BEHAVIOR_TYPE) {
    BEHAVIOR_TYPE["SAVE_FAILURE_FEEDBACK"] = "saveFailureFeedback";
    BEHAVIOR_TYPE["SAVE_SUCCESS_FEEDBACK"] = "saveSuccessFeedback";
})(BEHAVIOR_TYPE || (BEHAVIOR_TYPE = {}));
export var USER_INPUT_FILTER_CONDITIONS;
(function (USER_INPUT_FILTER_CONDITIONS) {
    USER_INPUT_FILTER_CONDITIONS["EQUALS"] = "eq";
    USER_INPUT_FILTER_CONDITIONS["NOT_EQUALS"] = "ne";
    USER_INPUT_FILTER_CONDITIONS["INCLUDES_ANY"] = "includesAny";
    USER_INPUT_FILTER_CONDITIONS["EXCLUDES_ANY"] = "excludesAny";
    USER_INPUT_FILTER_CONDITIONS["INCLUDES_ALL"] = "includesAll";
    USER_INPUT_FILTER_CONDITIONS["GREATER_THAN_OR_EQUAL"] = "ge";
    USER_INPUT_FILTER_CONDITIONS["LESS_THAN_OR_EQUAL"] = "le";
    USER_INPUT_FILTER_CONDITIONS["IN_BETWEEN"] = "inBetween";
    USER_INPUT_FILTER_CONDITIONS["OUTSIDE_OF"] = "outsideOf";
})(USER_INPUT_FILTER_CONDITIONS || (USER_INPUT_FILTER_CONDITIONS = {}));
//# sourceMappingURL=index.js.map